import React from 'react';
import { Chip } from '../../tcn/ui-kit';
import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Module 3 — A3.1 Scorecard row (mobile), pixel-faithful to mockup
 * `module3-tiers.jsx` M3_S1_Scorecard:
 *   - regular: 42×42 surface3 badge (cyan "T{n}") + "Tier N — {threshold}" +
 *     "{n} creator(s) · {dia}M MTD" + completion Chip (green≥80 / amber≥60 / red)
 *   - totals: cyan-gradient card, "Σ" badge, cyan "Totals", amber completion chip
 *
 * Props:
 *   - tier, label (e.g. "Tier 6 — 700K"), count, diamondsMtd (raw diamonds),
 *     completionPct (number|null), isTotals (bool)
 */
const fmtM = (raw) => `${(Number(raw || 0) / 1_000_000).toFixed(2)}M`;

const compColor = (pct) =>
  pct == null ? TCN.textMute : pct >= 80 ? TCN.green : pct >= 60 ? TCN.amber : TCN.red;

const TierScorecardRow = ({ tier, label, count = 0, diamondsMtd = 0, completionPct = null, isTotals = false, onClick }) => {
  if (isTotals) {
    return (
      <div
        style={{
          padding: 14,
          background: 'linear-gradient(135deg, #102028, #0a1418)',
          border: `1px solid ${TCN.cyan}55`,
          borderRadius: 12,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <div
          style={{
            width: 42, height: 42, borderRadius: 10, background: TCN.cyan, color: '#000',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 800,
          }}
        >
          Σ
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: TCN.cyan }}>Totals</div>
          <div style={{ fontSize: 11, color: TCN.textDim, marginTop: 2 }}>
            {count} creators · {fmtM(diamondsMtd)} MTD
          </div>
        </div>
        <Chip color={completionPct == null ? 'amber' : compColor(completionPct)} size="sm">
          {completionPct == null ? '—' : `${Math.round(completionPct)}%`}
        </Chip>
      </div>
    );
  }

  return (
    <div
      onClick={onClick ? () => onClick(tier) : undefined}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(tier);
              }
            }
          : undefined
      }
      style={{
        padding: 14,
        background: TCN.surface1,
        border: `1px solid ${TCN.border}`,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <div
        style={{
          width: 42, height: 42, borderRadius: 10, background: TCN.surface3,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 13, fontWeight: 700, color: TCN.cyan,
        }}
      >
        T{tier}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: TCN.text }}>{label}</div>
        <div style={{ fontSize: 11, color: TCN.textMute, marginTop: 2 }}>
          {count} creator{count === 1 ? '' : 's'} · {fmtM(diamondsMtd)} MTD
        </div>
      </div>
      <Chip color={compColor(completionPct)} size="sm">
        {completionPct == null ? '—' : `${Math.round(completionPct)}%`}
      </Chip>
    </div>
  );
};

export default TierScorecardRow;
